// src/pages/quality/QualityLayout.jsx
import React from "react";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";

export default function QualityLayout() {
  const { title, base, sections } = projectMenus.quality;

  return <SidebarLayout title={title} base={base} sections={sections} />;
}
